// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3b1pY","label":"Radio_label__3MOT8","checkMark":"Radio_checkMark__Cn23C","disabled":"Radio_disabled__3xvPI"};